﻿import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon } from "@blueprintjs/core";
import './Status.css';
import classNames from 'classnames';
import { Tooltip } from 'components/tooltip';
import './EmployeeCircleStatus.css';
import './StatusPanel.css';

export function TrendStatus(
    {
        trend = null,
        className = ""
    }
) {

    const [trendClass, setTrendClass] = useState("");
    const [trendIcon, setTrendIcon] = useState("");
    const [trendValue, setTrend] = useState("");
    const [trendTooltip, setTrendTooltip] = useState("");

    useEffect(() => {

        if (trend == null) {
            setTrendClass("");
            setTrendIcon("");
            setTrend("");
            return;
        }

        if (trend > 0) {
            setTrendIcon("trending-up");
            setTrendClass("status-trend-up");
            setTrendTooltip(`Risk Score is ${trend} more than previous period`);
        } else if (trend < 0) {
            setTrendIcon("trending-down");
            setTrendClass("status-trend-down");
            setTrendTooltip(`Risk Score is ${trend} less than previous period`);
        } else {
            setTrendIcon("layout-linear");
            setTrendClass("status-trend-even");
            setTrendTooltip("Risk Score is the same as the previous period");
        }

        // Show the absolute value of the trend
        setTrend(`${Math.abs(trend)}`);

    }, [trend])

    return (
        <Tooltip content={trendTooltip}>
            <div className={classNames("status-trend", trendClass, className)}>
                <span>{trendValue}</span> <Icon icon={trendIcon} />
            </div>
        </Tooltip>
    );
}

TrendStatus.propTypes = {
    trend: PropTypes.number,
    className: PropTypes.string
};